import React from 'react';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    // Bind method to use standard ES6 syntax compatible with stricter linters
    this.handleReload = this.handleReload.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('AppErrorBoundary caught an error:', error, info);
  }

  handleReload() {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
          <div className="max-w-lg w-full bg-white shadow-lg rounded-xl p-6 border border-red-200">
            <h1 className="text-2xl font-semibold text-red-600 mb-3">
              Oops, something went wrong.
            </h1>
            <p className="text-gray-700 mb-4">
              The app hit an unexpected error and had to stop. This is a safety screen so it doesn&apos;t just go blank.
            </p>
            {this.state.error && (
              <pre className="text-xs bg-gray-100 p-3 rounded-lg overflow-auto max-h-40 text-red-700 mb-4">
                {this.state.error.message || String(this.state.error)}
              </pre>
            )}
            <button
              onClick={this.handleReload}
              className="px-4 py-2 rounded-md bg-blue-600 text-white font-medium hover:bg-blue-700"
            >
              Reload app
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}